<!-- <div class="container" *ngIf="post$ | async as post; else loading">
    <mat-card class="post-card">
         <img matCardImage class="align-center img" [src]="post.imagePost" />
        <mat-card-content>
            <mat-card-title>
                {{ post.titlePost }}
            </mat-card-title>
          <p class="content">
                   {{ post.contentPost }}
            </p>

        </mat-card-content>
    </mat-card>
</div> -->
<!-- <div class="container"  *ngIf="listaPosts.length>0 && mostrar">
    <input type="button" routerLink="/" class="btn btn-primary mb-1 float-right" value="Inicio">
    <mat-card class="post-card" *ngFor="let post of listaPosts">
         <img matCardImage class="align-center img" (click)="buscarPost(post.id)" [src]="post.imagePost" />
        <mat-card-content (click)="buscarPost(post.id)">
            <mat-card-title>
                {{ post.titlePost }}
            </mat-card-title>
        </mat-card-content>
    </mat-card>
</div> -->
<input type="button" *ngIf="mostrar" routerLink="/" class="btn btn-primary ml-3 mb-2 float-left" value="Inicio">
<div class="container" *ngIf="listaPosts.length>0 && mostrar">
    
    <mat-card class="post-card" *ngFor="let post of listaPosts">
        <div class="card bg-dark text-white"  (click)="buscarPost(post.id)">
            <img [src]="post.imagePost" />
            <div class="card-img-overlay">
                <h5 class="card-title">   {{ post.titlePost }}</h5>
            </div>
        </div>
    </mat-card>
</div>




<!-- <div class="card bg-dark text-white" [routerLink]="['/post', post.id]">
    <img [src]="post.imagePost" [routerLink]="['/post', post.id]" />
    <div class="card-img-overlay">
        <h5 class="card-title" [routerLink]="['/post', post.id]"> {{ post.titlePost }}</h5>
    </div>
</div> -->

<form [formGroup]="editPostForm">
    <div *ngIf="!mostrar">
        <input type="button" (click)="mostrar=!mostrar" class="btn btn-secondary ml-3 mb-2" value="Atrás">
        <input type="button" routerLink="/" class="btn btn-primary ml-3 mb-2 float-left" value="Inicio">
        <angular-editor formControlName="contentPost" [config]="config"></angular-editor>
    </div>
  
</form>

<!-- <form [formGroup]="editPostForm">
    <angular-editor formControlName="contentPost" [config]="config"></angular-editor>
</form> -->
<ng-template #loading>
    <div class="container-spinner">
        <mat-spinner></mat-spinner>
    </div>
</ng-template>
